/* eslint-disable import/no-anonymous-default-export */
import { useLazyQuery, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import {
  getOperationFinances,
  getOperationFinancesDone,
} from '../graphql/query';
import {
  createOperationFinance,
  createMultiOperationFinance,
  deleteOperationFinance,
} from '../graphql/mutation';

export default ({ start, end, type }: any) => {
  const [getDeparts, depData]: any = useLazyQuery(getOperationFinances, {
    variables: { start, end },
  });
  const [getdone, doneData]: any = useLazyQuery(getOperationFinancesDone, {
    variables: { start, end },
  });

  const refetchQueries = [
    { query: getOperationFinances, variables: { start, end } },
    { query: getOperationFinancesDone, variables: { start, end } },
  ];

  const [addOperationFinance] = useMutation(createOperationFinance, {
    refetchQueries,
  });
  const [addMultiOperationFinance] = useMutation(createMultiOperationFinance, {
    refetchQueries,
  });
  const [removeOperationFinance] = useMutation(deleteOperationFinance, {
    refetchQueries,
  });

  useEffect(() => {
    getDeparts();
  }, [getDeparts]);

  useEffect(() => {
    getdone();
  }, [getdone]);

  const operationfinances = depData?.data?.['getOperationFinances']?.data || [];
  const finalOperationFinances = type
    ? operationfinances.filter((op: any) => op.opType === type)
    : operationfinances;

  const operationfinancesdone =
    doneData?.data?.['getOperationFinancesDone']?.data || [];
  const finalOperationFinancesdone = type
    ? operationfinancesdone.filter((op: any) => op.opType === type)
    : operationfinancesdone;

  const refreshoperationfinances = () => depData?.refetch();
  const refreshoperationfinancesdone = () => doneData?.refetch();
  return {
    operationfinances: finalOperationFinances,
    operationfinancesdone: finalOperationFinancesdone,
    refreshoperationfinances,
    refreshoperationfinancesdone,
    addOperationFinance,
    addMultiOperationFinance,
    removeOperationFinance,
  };
};
